import { RouteType } from "types/RouteType";
import BuildBoardStore from "./BuildBoardStore";

/**
 * `/devops/pipelines` — every build running, queued, failing or recently
 * finished across EVERY Azure DevOps project, grouped by client (or project)
 * and split into client work and internal work. One screen, no project picker.
 *
 * The route NAME and path are the page's identity (nav, page-visibility rows,
 * deep links) and were kept when the page was redone; the one-project build
 * DEFINITIONS view lives on as Project 360's Pipelines tab (PipelinesBoard/).
 */
const buildBoardRoute: RouteType[] = [
  {
    name: "Pipelines",
    path: "/devops/pipelines",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Pipelines",
        enableRefreshButton: true,
        component: () => import("./BuildBoard.Header"),
      },
      body: {
        component: () => import("./BuildBoard.Body"),
        grayBackground: true,
      },
    },
    group: "DevOps",
    searchAliases: ["builds", "ci", "build queue", "running builds", "failed builds"],
    // Reads are staff (the API's requireStaffRead); cancel / re-run are
    // operator+ and the API enforces that, the page only hides the buttons.
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = rootStore.buildBoardStore as BuildBoardStore | undefined;
      store?.initialize();
    },
    // Tear down the live subscription and the poll/clock timers on leave.
    onExit: ({ rootStore }) => {
      const store = rootStore.buildBoardStore as BuildBoardStore | undefined;
      store?.dispose();
    },
  },
];

export default buildBoardRoute;
